module.exports = {
  fr: {
    selected: {
      label: "Français",
      code: "fr",
    },
    quote: {
      label: "Devis",
      url: "/devis-reservation-vtc/",
    },
    home: {
      label: "Accueil",
      url: "/",
    },
    blog: {
      label: "Blog",
      url: "/blog/",
    },
    phone: "06 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/",
    },
  },
  en: {
    selected: {
      label: "English",
      code: "en",
    },
    quote: {
      label: "Quotes",
      url: "/en/devis-reservation-vtc/",
    },
    home: {
      label: "Home",
      url: "/en/",
    },
    blog: {
      label: "Blog",
      url: "/en/blog/",
    },
    phone: "+33 6 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/en/",
    },
  },
  ru: {
    selected: {
      label: "Русский",
      code: "ru",
    },
    quote: {
      label: "котировка",
      url: "/ru/devis-reservation-vtc/",
    },
    home: {
      label: "дома",
      url: "/ru/",
    },
    blog: {
      label: "блог",
      url: "/ru/blog/",
    },
    phone: "+33 6 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/ru/",
    },
  },
  de: {
    selected: {
      label: "Deutsch",
      code: "de"
    },
    quote: {
      label: "Angebot",
      url: "/de/devis-reservation-vtc/"
    },
    home: {
      label: "Startseite",
      url: "/de/"
    },
    blog: {
      label: "Blog",
      url: "/de/blog/"
    },
    phone: "+33 6 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/de/"
    }
  },
  it: {
    selected: {
      label: "Italiano",
      code: "it"
    },
    quote: {
      label: "Preventivo",
      url: "/it/devis-reservation-vtc/"
    },
    home: {
      label: "Home",
      url: "/it/"
    },
    blog: {
      label: "Blog",
      url: "/it/blog/"
    },
    phone: "+33 6 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/it/"
    }
  },
  es: {
    selected: {
      label: "Español",
      code: "es"
    },
    quote: {
      label: "Presupuesto",
      url: "/es/devis-reservation-vtc/"
    },
    home: {
      label: "Inicio",
      url: "/es/"
    },
    blog: {
      label: "Blog",
      url: "/es/blog/"
    },
    phone: "+33 6 60 26 53 36",
    brand: {
      label: "Davoyage",
      url: "/es/"
    }
  }
};
